import React, { Fragment } from 'react';
import HomeMultiplyMunicipal from 'containers/home-municipal-multiply';
import HomeMultiplyRegional from 'containers/home-regional-multiply';
import PactometroSiNoContainer from 'components/pactometro-si-no';
import HomeMunicipalDetail from 'containers/home-municipal-detail';
import { useRESTDataCache } from '../../dataProvider';
import { SUBTYPES, TYPES } from '../../envs';
import Card from '../../components/card';
import BarsContainer from '../bars';
import HomeDoble from '../doubleHome';
import HomeRegional from '../regional';
import HomeMunicipal from '../municipal';
import {
  getModuleAmp,
  getModuleOCWeb,
  getModuleWeb,
  MODULE_TYPES
} from './utils';
import Pactometro from '../pactometro';

import SumaBloques from '../sumaBloques';
import RankingPactometro from '../rankingPactometro';
import { PROPERTIES_JSON } from '../../core/constants';
import { LA_SEXTA, ONDACERO, ANTENA3, LA_RAZON } from '../../constants/sites';

import LoadingPlaceholder from '../../components/loadingPlaceholder';

const getAMPHeight = componentType => {
  switch (componentType) {
    case MODULE_TYPES.HOME_NOT_CENTRALIST:
      // todo pendiente de ver el tamaño del nuevo modulo
      return 800; // resultados;
    case MODULE_TYPES.PACT_SI_O_NO:
      // todo pendiente de ver el tamaño del nuevo modulo
      return 800; // resultados;
    case MODULE_TYPES.HOME:
      return 800; // resultados;
    case MODULE_TYPES.HOME_DETAIL:
      return 800; // resultados;
    case MODULE_TYPES.HOME_DOBLE:
      return 1080; // resultadosDobles;
    case MODULE_TYPES.PACTOS:
      return 350; // pactometro;
    case MODULE_TYPES.BARRAS:
      return 360; // bars;
    case MODULE_TYPES.RANKING:
      return 760; // rankingPactometro;
    case MODULE_TYPES.MINI:
      return 260; // sumaBloques;
    default:
      throw new Error('Error');
  }
};

const getUrlImg = site => {
  switch (site) {
    case LA_SEXTA:
      return 'https://statics.atresmedia.com/elecciones/loading_icon.gif';
    case ONDACERO:
      return 'https://statics.atresmedia.com/elecciones/loading_icon.gif';
    case ANTENA3:
      return 'https://statics.atresmedia.com/elecciones/loading_icon.gif';
    case LA_RAZON:
      return 'https://statics.atresmedia.com/elecciones/loading_icon.gif';
    default:
      return '';
  }
};

const getParams = ({ community, province, town }) => {
  if (town) {
    return `${community}/${province}/${town}`;
  }
  if (province) {
    return `${community}/${province}`;
  }
  if (community) {
    return `${community}`;
  }
  return '';
};

const getUrl = (componentType, matchParams) => {
  const {
    type,
    country,
    allMap,
    navigableMode,
    chartType,
    community,
    province,
    town,
    year,
    placesId,
    placeId,
    electionNumber,
    showMasterBar
  } = matchParams;
  if (type === TYPES.MUNICIPAL) {
    switch (componentType) {
      case MODULE_TYPES.HOME_DETAIL:
        return `/${country}/${navigableMode}/${year}/${type}/${electionNumber}/${showMasterBar}/home-municipales-detalle-resultados.html`;
      case MODULE_TYPES.HOME_NOT_CENTRALIST:
        return `/${country}/${navigableMode}/${year}/${type}/${electionNumber}/${chartType}/${showMasterBar}/${placesId}/home-multiply-municipales-resultados.html`;
      case MODULE_TYPES.HOME:
        return `/${country}/${navigableMode}/${year}/${type}/${electionNumber}/${chartType}/${showMasterBar}/${
          town ? getParams({ community, province, town }) : placeId
        }/${
          town
            ? 'detalle-municipales-resultados.html'
            : 'home-municipales-resultados.html'
        }`;
      case MODULE_TYPES.PACTOS:
        return `/${navigableMode}/${year}/${type}/${electionNumber}/${showMasterBar}/${placeId}/pactometro.html`;
      case MODULE_TYPES.BARRAS:
        return `/${navigableMode}/${year}/${type}/${electionNumber}/${showMasterBar}/${placeId}/bars.html`;
      case MODULE_TYPES.RANKING:
        return `/${navigableMode}/${year}/${type}/${electionNumber}/${showMasterBar}/${placeId}/rankingPactometro.html`;
      case MODULE_TYPES.MINI:
        return `/${navigableMode}/${year}/${type}/${electionNumber}/${showMasterBar}/${placeId}/sumaBloques.html`;
      default:
        return `/${country}/${navigableMode}/${year}/${type}/${electionNumber}/${chartType}/${showMasterBar}/${placesId}/home-multiply-municipales-resultados.html`;
    }
  }

  if (type === TYPES.REGIONAL) {
    switch (componentType) {
      case MODULE_TYPES.HOME_NOT_CENTRALIST:
        return `/${country}/${navigableMode}/${year}/${type}/${electionNumber}/${chartType}/${showMasterBar}/1/${placesId}/home-multiply-regional-resultados.html`;
      case MODULE_TYPES.HOME:
        return `/${country}/${navigableMode}/${year}/${type}/${electionNumber}/${chartType}/${showMasterBar}/${allMap}/${getParams(
          { community, province, town }
        )}/home-regionales-resultados.html`;
      case MODULE_TYPES.PACTOS:
        return `/${navigableMode}/${year}/${type}/${electionNumber}/${showMasterBar}/${community}/pactometro.html`;
      case MODULE_TYPES.BARRAS:
        return `/${navigableMode}/${year}/${type}/${electionNumber}/${showMasterBar}/${community}/bars.html`;
      case MODULE_TYPES.RANKING:
        return `/${navigableMode}/${year}/${type}/${electionNumber}/${showMasterBar}/${community}/rankingPactometro.html`;
      case MODULE_TYPES.MINI:
        return `/${navigableMode}/${year}/${type}/${electionNumber}/${showMasterBar}/${community}/sumaBloques.html`;
      case MODULE_TYPES.PACT_SI_O_NO:
        return `/${navigableMode}/${year}/${type}/${electionNumber}/${showMasterBar}/${community}/pactos-si-no.html`;
      default:
        return `/${country}/${navigableMode}/${year}/${type}/${electionNumber}/${chartType}/${showMasterBar}/1/${placesId}/home-multiply-regional-resultados.html`;
    }
  }
  return `default`;
};

const getEsiId = (componentType, matchParams) => {
  const { community, province, town, placeId, placesId, currentPlace, type } =
    matchParams;
  switch (componentType) {
    case MODULE_TYPES.HOME_NOT_CENTRALIST:
      return placesId;
    case MODULE_TYPES.HOME_DETAIL:
      return 'C108';
    case MODULE_TYPES.HOME:
      if (type === TYPES.REGIONAL) {
        return currentPlace.ineId;
      }
      if (type === TYPES.MUNICIPAL) {
        if (town) {
          return currentPlace.ineId;
          // return getParams({ community, province, town });
        }
        return placeId;
      }
      break;
    default:
      return placesId;
  }
  return '';
};

const Module = data => {
  const params = useRESTDataCache(PROPERTIES_JSON(), 'GLOBAL_CONFIG', null);
  const { componentType, matchParams } = data;

  const { site, year, electionNumber, type } = matchParams;
  const moduleId = `elections_module_${new Date().getTime()}`;
  const url = getUrl(componentType, matchParams).replace(/[\s\n]+/g, '');

  const urlImg = getUrlImg(site);
  const moduleHeight = getAMPHeight(componentType);
  const esiID = getEsiId(componentType, matchParams);
  const moduleWeb = () => {
    switch (site) {
      case ONDACERO:
        return getModuleOCWeb(
          moduleId,
          url,
          moduleHeight,
          '2',
          esiID,
          year,
          type,
          componentType === TYPES.GENERAL ? SUBTYPES.CONGRESS : SUBTYPES.SINGLE,
          electionNumber
        );
      case ANTENA3:
        return getModuleWeb(
          moduleId,
          url,
          '41',
          esiID,
          year,
          type,
          componentType === TYPES.GENERAL ? SUBTYPES.CONGRESS : SUBTYPES.SINGLE,
          electionNumber
        );
      case LA_SEXTA:
        return getModuleWeb(
          moduleId,
          url,
          '7',
          esiID,
          year,
          type,
          componentType === TYPES.GENERAL ? SUBTYPES.CONGRESS : SUBTYPES.SINGLE,
          electionNumber
        );
      case LA_RAZON:
        return getModuleWeb(
          moduleId,
          url,
          '48',
          esiID,
          year,
          type,
          componentType === TYPES.GENERAL ? SUBTYPES.CONGRESS : SUBTYPES.SINGLE,
          electionNumber
        );
      default:
        return getModuleWeb(
          moduleId,
          url,
          '',
          esiID,
          year,
          type,
          componentType === TYPES.GENERAL ? SUBTYPES.CONGRESS : SUBTYPES.SINGLE,
          electionNumber
        );
    }
  };
  const moduleAmp = getModuleAmp(url, moduleHeight, urlImg);

  const match = { params: matchParams };

  const handleCopyToClipboard = async (e, text) => {
    e.persist();

    const originalText = e.target.innerHTML;

    await navigator.clipboard.writeText(text);
    e.target.innerHTML = 'Copiado ✔';

    setTimeout(() => {
      e.target.innerHTML = originalText;
    }, 3000);
  };

  if (!params) {
    return <LoadingPlaceholder />;
  }

  return (
    <div>
      <Card title="Vista previa" className="vistaprevia" isCollapsed={false}>
        <Fragment>
          {match && matchParams.type === TYPES.REGIONAL && (
            <Fragment>
              {componentType === MODULE_TYPES.HOME_NOT_CENTRALIST && (
                <HomeMultiplyRegional match={match} />
              )}
              {componentType === MODULE_TYPES.BARRAS && (
                <BarsContainer match={match} />
              )}
              {componentType === MODULE_TYPES.HOME && (
                <HomeRegional match={match} />
              )}
              {componentType === MODULE_TYPES.HOME_DOBLE && (
                <HomeDoble match={match} />
              )}
              {componentType === MODULE_TYPES.PACTOS && (
                <Pactometro match={match} />
              )}
              {componentType === MODULE_TYPES.MINI && (
                <SumaBloques match={match} />
              )}
              {componentType === MODULE_TYPES.RANKING && (
                <RankingPactometro match={match} />
              )}
              {componentType === MODULE_TYPES.PACT_SI_O_NO && (
                <PactometroSiNoContainer match={match} />
              )}
            </Fragment>
          )}

          {match && matchParams.type === TYPES.MUNICIPAL && (
            <Fragment>
              {componentType === MODULE_TYPES.HOME_DETAIL && (
                <HomeMunicipalDetail match={match} />
              )}
              {componentType === MODULE_TYPES.HOME_NOT_CENTRALIST && (
                <HomeMultiplyMunicipal match={match} />
              )}
              {componentType === MODULE_TYPES.BARRAS && (
                <BarsContainer match={match} />
              )}
              {componentType === MODULE_TYPES.HOME && (
                <HomeMunicipal match={match} />
              )}
              {componentType === MODULE_TYPES.HOME_DOBLE && (
                <HomeDoble match={match} />
              )}
              {componentType === MODULE_TYPES.PACTOS && (
                <Pactometro match={match} />
              )}
              {componentType === MODULE_TYPES.MINI && (
                <SumaBloques match={match} />
              )}
              {componentType === MODULE_TYPES.RANKING && (
                <RankingPactometro match={match} />
              )}
            </Fragment>
          )}
        </Fragment>
      </Card>

      <Card title="Módulos" className="vistaprevia">
        <div className="two">
          <h3>Módulo web</h3>
          <div className="preview-code">
            <textarea readOnly value={moduleWeb()} />
            <div className="preview-code__button-container">
              <button
                type="button"
                className="button"
                onClick={e => handleCopyToClipboard(e, moduleWeb())}
              >
                Copiar
              </button>
            </div>
          </div>
        </div>
        <div className="two">
          <h3>Módulo AMP</h3>
          <div className="preview-code">
            <textarea readOnly value={moduleAmp} />
            <div className="preview-code__button-container">
              <button
                type="button"
                className="button"
                onClick={e => handleCopyToClipboard(e, moduleAmp)}
              >
                Copiar
              </button>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default Module;
